import React from 'react';
import { useIsUnifiedSidebarEnabled } from '../../hooks/useIsUnifiedSidebarEnabled';
import UnifiedNavigation from '../UnifiedSidebar/UnifiedNavigation';
import RegularNavigation from './Navigation';
import arePropsEqual from 'react-fast-compare';

const Navigation = (props) => {
  const isUnifiedSidebarEnabled = useIsUnifiedSidebarEnabled();
  return isUnifiedSidebarEnabled ? (
    <UnifiedNavigation {...props} />
  ) : (
    <RegularNavigation {...props} />
  );
};

export default React.memo(Navigation, arePropsEqual);
